import {createFeatureSelector} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {UserActions, UserActionTypes} from '../actions/user.actions';
import {QueryParamsModel} from '../_base/crud';
import {UserModel} from '../models/user.model';

export interface UsersState extends EntityState<UserModel> {
    listLoading: boolean;
    actionsLoading: boolean;
    totalCount: number;
    lastCreatedUserId: number | undefined;
    lastUpdatedUserId: number | undefined;
    showInitWaitingMessage: boolean;
    error_code: number;
    error_message: string | undefined;
}

export const adapter: EntityAdapter<UserModel> = createEntityAdapter<UserModel>();

export const initialUsersState: UsersState = adapter.getInitialState({
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    lastCreatedUserId: undefined,
    lastUpdatedUserId: undefined,
    showInitWaitingMessage: true,
    error_code: 0,
    error_message: undefined
});

export function usersReducer(state = initialUsersState, action: UserActions): UsersState {
    switch (action.type) {
        case UserActionTypes.USERS_LOADING: {
            return {
                ...state,
                listLoading: action.payload.isLoading,
                lastCreatedUserId: undefined,
                error_code: 0,
                error_message: undefined
            };
        }
        case UserActionTypes.USERS_BUSY: {
            return {
                ...state,
                actionsLoading: action.payload.isLoading,
                error_code: 0,
                error_message: undefined
            };
        }
        case UserActionTypes.CREATE_USER: {
            return {
                ...state,
                error_code: 0,
                error_message: undefined
            };
        }
        case UserActionTypes.USER_CREATED: {
            return adapter.addOne(action.payload.user, {
                ...state,
                lastCreatedUserId: action.payload.user.id,
                error_code: 0,
                error_message: undefined
            });
        }
        case UserActionTypes.UPDATE_USER: {
            return adapter.updateOne(action.payload.partialUser, {
                ...state,
                error_code: 0,
                error_message: undefined,
            });
        }
        case UserActionTypes.USER_UPDATED: {
            return {
                ...state,
                lastUpdatedUserId: action.payload.user.id,
                error_code: 0,
                error_message: undefined
            };
        }
        case UserActionTypes.DELETE_USER: {
            return adapter.removeOne(action.payload.id, state);
        }
        case UserActionTypes.USERS_LOADED: {
            return adapter.addMany(action.payload.users, {
                ...initialUsersState,
                totalCount: action.payload.totalCount,
                listLoading: false,
                showInitWaitingMessage: false
            });
        }
        case UserActionTypes.USERS_ERROR: {
            return {
                ...state,
                error_code: action.payload.error_code,
                error_message: action.payload.message
            };
        }
        default: return state;
    }
}

export const getUserState = createFeatureSelector<UsersState>('users');

export const {
    selectAll: selectAllUsers,
} = adapter.getSelectors();
